import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditSegmentsForm from './EditSegmentsForm'
import ModalHeader from './ModalHeader'

const EditSegmentsModal = props => {
  return (
    <ControlledModal fullScreen noPadding {...props}>
      <ModalHeader />

      <PermissionChecker any={['createSegment', 'editSegment']}>
        <EditSegmentsForm />
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditSegmentsModal
